require('normalize.css/normalize.css');
require('./styles/index.scss');

import Mouse from "./utils/mouse"

const getRandomColor = () => {
	let letters = "0123456789ABCDEF"
	let color = "#"
	for (let i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * 16)]
	}
	return color
}

const canvas = document.querySelector('.main-canvas')
canvas.width = window.innerWidth * window.devicePixelRatio
canvas.height = window.innerHeight * window.devicePixelRatio
const ctx = canvas.getContext("2d")

// ctx.fillRect(0 ,0, canvas.width/2, canvas.height/2)

// rectangle
/*ctx.beginPath()
ctx.fillStyle = 'white'
ctx.rect(75, 75, canvas.width/2, canvas.height/2)
ctx.fill()
ctx.closePath()*/

// Cercle
/*ctx.beginPath()
ctx.fillStyle = '#00C158'
ctx.arc(300, 300, 75, 0, Math.PI * 2, true)
ctx.fill()
ctx.closePath()*/

// Triangle
/*ctx.beginPath()
ctx.fillStyle = 'blue'
ctx.lineWidth = 10
ctx.strokeStyle = '#00C158'
ctx.moveTo(canvas.width / 4 - 50, canvas.height / 4 + 50)
ctx.lineTo(canvas.width / 4, canvas.height/4 - 50)
ctx.lineTo(canvas.width / 4 + 50, canvas.height / 4 + 50)
ctx.lineTo(canvas.width / 4 - 50, canvas.height / 4 + 50)
ctx.stroke()
ctx.closePath()*/

// Lignes dans tous les sens
/*ctx.beginPath()
for (let i = 0; i < 100; i++) {
    ctx.strokeStyle = getRandomColor()
    ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height)
    ctx.lineTo(Math.random() * canvas.width , Math.random() * canvas.height)
    ctx.stroke()
}
ctx.closePath()*/

// Triangle tourné
/*ctx.save()
ctx.beginPath()
ctx.strokeStyle = '#00C158'
ctx.translate(canvas.width/2, canvas.height/2)
ctx.rotate(90)
ctx.moveTo(-50, 50)
ctx.lineTo(0, -50)
ctx.lineTo(50, 50)
ctx.lineTo(-50, 50)
ctx.stroke()
ctx.closePath()
ctx.restore()*/

const color = getRandomColor()

const opacityRect = (opacity) => {
	ctx.beginPath()
	// ctx.fillStyle = `rgba(0, 0, 0, ${opacity})`
	ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`
	ctx.rect(0,0, canvas.width, canvas.height)
	ctx.fill()
	ctx.closePath()
}

/*const drawDot = (delay) => {
	ctx.beginPath()
	ctx.fillStyle = '#00C158'
	ctx.arc(Math.cos(time * delay) * (radius * time), Math.sin(time) * (radius * time * delay), 10, 0, Math.PI * 2)
	ctx.fill()
	ctx.closePath()
}*/

const drawCircleAtAngle = (angle, radius) => {
	ctx.beginPath()
	// ctx.fillStyle = color
	ctx.fillStyle = '#00C158'
	// ctx.fillStyle = getRandomColor()
	ctx.arc(Math.cos(angle) * radius , Math.sin(angle) * radius, 10, 0, Math.PI * 2)
	ctx.fill()
	ctx.closePath()
}

let time = 0
const update = ()=>{
	const mouseX = ((Mouse.cursor[0] + 1)/2) * canvas.width
	const mouseY = ((Mouse.cursor[1] + 1)/2) * canvas.height

	ctx.save()
	opacityRect(0.1)
	// ctx.translate(canvas.width/2, canvas.height/2)
	ctx.translate(mouseX, mouseY)

	for (let i = 0; i < 500; i++) {
		drawCircleAtAngle(
			Math.PI * (i*0.1) + time,
			(Math.sin(time * .365) * (i*.5) * 50) + 20
		)
	}

	ctx.restore()
	time += 0.04

	requestAnimationFrame(update)
}
requestAnimationFrame(update)
